"use strict";

class Helpers {
    constructor(initALL = true, img) {
        console.log('Init Helpers module');
        if (initALL) this.initInfoLinks().initNumberInputs();

        this.img = img;
    }

    initInfoLinks() {
        $('.convectors-menu a[data-toggle="pill"], .reserves-menu a[data-toggle="pill"]').on('shown.bs.tab', event => {
            let infoLink = "#";
            let tmpArray = event.target.href.split('#');
            let selectedTabName = tmpArray[tmpArray.length - 1];
            switch (selectedTabName) {
                case "ITT":
                    infoLink = "http://itermic.ru/catalog/trench/natural/regular.jsp";
                    break;
                case "ITTB":
                    infoLink = "http://itermic.ru/catalog/trench/blower/regular.jsp";
                    break;
                case "ITTL":
                    infoLink = "http://itermic.ru/catalog/trench/natural/low-profile-regular.jsp";
                    break;
                case "ITTBL":
                    infoLink = "http://itermic.ru/catalog/trench/blower/low-profile-regular.jsp";
                    break;
                case "ITTZ":
                    infoLink = "http://itermic.ru/catalog/trench/natural/zinc-regular.jsp";
                    break;
                case "ITTBZ":
                    infoLink = "http://itermic.ru/catalog/trench/blower/zinc-regular.jsp";
                    break;
                case "ITF":
                    infoLink = "http://itermic.ru/catalog/radiators/";
                    break;
                case "automation":
                    infoLink = "http://itermic.ru/catalog/automation/";
                    break;
            }
            $("#infoLink").prop("href", infoLink).find(".label").text("О серии " + selectedTabName);
        }).filter("[href='#ITT']").tab('show');

        return this;
    }

    initNumberInputs() {
        $("body").on("change", "input[type=number]", (event) => {
            event.currentTarget.value = parseInt(event.currentTarget.value);
        });

        return this;
    }

    static hash(source) {
        /* Simple hash function. */
        var a = 1, c = 0, h, o;
        if (source) {
            a = 0;
            /*jshint plusplus:false bitwise:false*/
            for (h = source.length - 1; h >= 0; h--) {
                o = source.charCodeAt(h);
                a = (a << 6 & 268435455) + o + (o << 14);
                c = a & 266338304;
                a = c !== 0 ? a ^ c >> 21 : a;
            }
        }
        return String(a);
    }

    static numberWithCommas(x) {
        return x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    static pad(number, paddingSize) {
        let s = String(number);
        while (s.length < (paddingSize || 2)) {
            s = "0" + s;
        }
        return s;
    }

    static cleanSpaces(aString) {
        return ((aString.replace) ? aString.replace(/[ \u00A0\u2007\u202F\u2060]/g, "") : "");
    }

    toString() {
        return JSON.stringify({
            img: this.img
        })
    }
}

export default Helpers;